import { TextAreaField } from '@aws-amplify/ui-react';
import { Box, Button, Card, CardActions, CardContent, Divider, FormControl, Select, MenuItem, Typography } from '@mui/material'
import React, { useState } from 'react'
import { API } from 'aws-amplify';

const Feedback = () => {
    const [category, setCategory] = useState("queryBuilder");
    const [description, setDescription] = useState("")

    const handleCancel = () => {

    }

    const handleSubmit = async () => {
        API.invoke('lambda', '/path/to/your/lambda/function', { body: { /* your payload */ } })
            .then(response => {
                // Handle the response from the Lambda function
            })
            .catch(error => {
                // Handle any errors
            });
    }

    return (
        <Card variant='outlined' sx={{
            width: '100%'
        }}>
            <Typography variant='h6' sx={{
                padding: 2
            }}>Feedback</Typography>
            <Divider></Divider>
            <CardContent>
                <Box sx={{
                    display: 'flex',
                    padding: 1
                }}>
                    <Box
                        sx={{
                            padding: 1,
                            width: '100%'
                        }}
                    >
                        <FormControl
                            fullWidth
                            variant="outlined"
                            sx={{
                                marginBottom: 2
                            }}
                        >
                            <Select
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                            >
                                <MenuItem value={"queryBuilder"}>Query Builder</MenuItem>
                                <MenuItem value={"other"}>Other</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl
                            fullWidth
                            variant="outlined"
                            sx={{
                                marginBottom: 2
                            }}
                        >
                            <TextAreaField
                                size='small'
                                id="verification-code"
                                label="Describe Feedback"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </FormControl>
                    </Box>
                </Box>
            </CardContent>
            <CardActions>
                <Button variant='outlined' color='error' onClick={() => handleCancel()} >Cancel</Button>
                <Button variant='outlined' onClick={() => handleSubmit()}>Submit</Button>
                <Button variant='outlined' onClick={() => {
                    const mailtoLink = "mailto:manashsahoo+zqzuhwoxpvscjkgngali@boards.trello.com?subject=Bug:"
                    window.open(mailtoLink, '_blank');
                }}>Email</Button>

            </CardActions>
        </Card >
    )
}

export default Feedback